import React from 'react'
import {Col, Divider, Form, Row} from "antd";
import HeaderName from "./HeaderName";
import HeaderDescription from "./HeaderDescription";
import HeaderCode from "./HeaderCode";
import HeaderUrlPath from "./HeaderUrlPath";

const HeadersContainer = () => {

    return (
        <React.Fragment>
            <h3>Reçete Bilgileri</h3>
            <Divider/>

            <Row justify={'start'}>
                <Col span={24}>
                    <Form
                        labelAlign={'left'}
                        labelCol={{span: 6}}
                        wrapperCol={{span: 16}}
                    >
                        <HeaderName/>
                        <HeaderCode />
                        <HeaderUrlPath />
                        <HeaderDescription/>
                    </Form>
                </Col>
            </Row>
        </React.Fragment>
    )
}
export default HeadersContainer